import React from 'react';
import { Box } from '@mui/material';
import { Button, ButtonSize, ButtonVariant, CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import styles from './styles.module.scss';
import { RiskResult } from '../../types';
import { TFunction } from 'i18next';

interface FooterButtonProps {
  risk: RiskResult;
  onClick: (risk: RiskResult) => void;
  t: TFunction;
  isUnlock: boolean;
}

const LockAndUnlockFooterComponent: React.FC<FooterButtonProps> = ({
  risk,
  onClick,
  t,
  isUnlock
}) => {
  return (
    <Box
      className={styles.buttonsContainer}
      data-testid={`footer-lock-container-${risk.scenarioNumber}`}
    >
      {isUnlock ? (
        <Button
          onClick={() => onClick(risk)}
          leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_unlock" />}
          name="actions"
          size={ButtonSize.SMALL}
          variant={ButtonVariant.PRIMARY}
          text={{ value: t('unlock-scenario') }}
          ariaText={{ value: t('unlock-scenario') }}
          aria-label={` ${t('unlock-scenario')} ${risk.scenarioNumber}`}
          data-testid={`footer-unlock-button-${risk.scenarioNumber}`}
        />
      ) : (
        <Button
          onClick={() => onClick(risk)}
          leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_lock_no_border" />}
          name="actions"
          size={ButtonSize.SMALL}
          variant={ButtonVariant.PRIMARY}
          text={{ value: t('lock') }}
          ariaText={{ value: t('lock') }}
          aria-label={`Lock scenario ${risk.scenarioNumber}`}
          data-testid={`footer-lock-button-${risk.scenarioNumber}`}
        />
      )}
    </Box>
  );
};

export const LockAndUnlockFooter = React.memo(LockAndUnlockFooterComponent);
